import {
  IconDots,
  IconPencil,
  IconPin,
  IconPinnedOff,
  IconTrash,
} from '@tabler/icons-react';
import { useAtomValue } from 'jotai';

import { IconButton, Menu, MenuItemProps } from '@cfa/react-core';

import { cn } from '@/utils/tailwind';

import { useHistoryItemActions } from '../actions';
import { isConversationPinnedAtomFamily } from '../state';

import { StoredConversation } from '@/routes/smart-search/types';

const MenuItem: React.FC<MenuItemProps<object>> = props => (
  <Menu.Item
    {...props}
    className={cn(
      'text-variant-body1! min-w-40! rounded-lg! px-2! py-1.5!',
      props.className,
    )}
  />
);

interface HistoryItemMenuProps {
  conversation: StoredConversation;
}

const HistoryItemMenu: React.FC<HistoryItemMenuProps> = ({ conversation }) => {
  const {
    handlePinConversation,
    handleUnpinConversation,
    handleDeleteConversation,
    handleRenameConversation,
  } = useHistoryItemActions(conversation.id);

  const isPinned = useAtomValue(
    isConversationPinnedAtomFamily(conversation.id),
  );

  return (
    <Menu.Root>
      <IconButton className="p-0!">
        <IconDots className="hover:text-contrast/60" />
      </IconButton>
      <Menu.Popover className="rounded-xl! p-1!">
        <Menu.Container className="">
          <MenuItem
            onAction={
              isPinned ? handleUnpinConversation : handlePinConversation
            }
          >
            {isPinned ? <IconPinnedOff size={20} /> : <IconPin size={20} />}
            {isPinned ? 'Unpin chat' : 'Pin chat'}
          </MenuItem>
          <MenuItem onAction={handleRenameConversation}>
            <IconPencil size={20} />
            Rename
          </MenuItem>
          <MenuItem
            className="hover:bg-feedback-error-base/10!"
            style={{ color: 'var(--color-feedback-error-base) !important' }}
            onAction={handleDeleteConversation}
          >
            <IconTrash className="text-feedback-error-base!" size={20} />
            Delete
          </MenuItem>
        </Menu.Container>
      </Menu.Popover>
    </Menu.Root>
  );
};

export default HistoryItemMenu;
